export default __webpack_public_path__ + "static/media/crew.b5ca2d23.svg";